import * as React from "react";
const SvgMinusLargeBold = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M19 11a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2z" /></svg>;
export default SvgMinusLargeBold;